function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_3400",
  "data-name": "Group 3400",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_939",
  "data-name": "Path 939",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_940",
  "data-name": "Path 940",
  d: "M6.17 18a3 3 0 015.66 0H22v2H11.83a3 3 0 01-5.66 0H2v-2zm6-7a3 3 0 015.66 0H22v2h-4.17a3 3 0 01-5.66 0H2v-2zm-6-7a3 3 0 015.66 0H22v2H11.83a3 3 0 01-5.66 0H2V4zM9 6a1 1 0 10-1-1 1 1 0 001 1zm6 7a1 1 0 10-1-1 1 1 0 001 1zm-6 7a1 1 0 10-1-1 1 1 0 001 1z",
  fill: "#fff"
})));